import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { MODE, STATUS, VALIDATION_TYPE } from './constants';
import GsheetIcon from '../resources/icons/gsheet_export.svg';
import CheckMark from '../resources/icons/check_mark.svg';
import css from './DownloadLog.css';

const AUDIT_BODY_KEY = {
    [VALIDATION_TYPE.GENERAL]: 'STATIC.LOGS_DOWNLOAD.BODY_AUDIT_GENERAL',
    [VALIDATION_TYPE.SDK]: 'STATIC.LOGS_DOWNLOAD.BODY_AUDIT_SDK',
    [VALIDATION_TYPE.EVENTS]: 'STATIC.LOGS_DOWNLOAD.BODY_AUDIT_EVENTS',
};

function DownloadLog({
    status,
    link,
    isGsheet,
    showErrorMessage,
    validationValid,
    mode,
    validationType,
    logType,
}) {
    const isFailure = status === STATUS.FAILED;
    const isAudit = mode === MODE.AUDIT;
    const showProcessing = !link && !isFailure && !validationValid;

    return (
        <section className={css.downloadLog}>
            <div className={css.formGroup}>
                {isGsheet && (
                    <div className={css.gsheetImage}>
                        <GsheetIcon className={css.gsheetIcon} />
                    </div>
                )}

                {showProcessing && (
                    <div className={css.header}>
                        {isAudit && <h2><Translate id="STATIC.LOGS_DOWNLOAD.HEADER_AUDIT" /></h2>}
                        {!isAudit && logType !== 'skan-simulations' && (
                            <h2><Translate id="STATIC.LOGS_DOWNLOAD.HEADER_PROCESSING" /></h2>
                        )}
                        {!isAudit && logType === 'skan-simulations' && (
                            <h2><Translate id="STATIC.LOGS_DOWNLOAD.HEADER_MODEL" /></h2>
                        )}
                        <h2><Translate id="STATIC.LOGS_DOWNLOAD.HEADER_WAIT" /></h2>
                    </div>
                )}

                {showProcessing && (
                    <div className={css.body}>
                        {isAudit ? (
                            <Translate id={AUDIT_BODY_KEY[validationType] || AUDIT_BODY_KEY[VALIDATION_TYPE.SDK]} />
                        ) : (
                            <div>
                                <Translate id="STATIC.LOGS_DOWNLOAD.BODY_EXPORT_KEEP_TAB" />
                                <br />
                                <Translate
                                    id={
                                        isGsheet
                                            ? 'STATIC.LOGS_DOWNLOAD.BODY_EXPORT_GSHEET_TAIL'
                                            : 'STATIC.LOGS_DOWNLOAD.BODY_EXPORT_FILE_TAIL'
                                    }
                                />
                            </div>
                        )}
                    </div>
                )}

                <div className={css.center}>
                    {link && !isFailure && !validationValid && !isGsheet && (
                        <div>
                            <div><Translate id="STATIC.LOGS_DOWNLOAD.DOWNLOAD_AUTO_1" /></div>
                            <div><Translate id="STATIC.LOGS_DOWNLOAD.DOWNLOAD_AUTO_2" /></div>
                        </div>
                    )}
                    {link && !isFailure && !validationValid && isGsheet && (
                        <div>
                            <div><Translate id="STATIC.LOGS_DOWNLOAD.GSHEET_AUTO_1" /></div>
                            <div><Translate id="STATIC.LOGS_DOWNLOAD.GSHEET_AUTO_2" /></div>
                        </div>
                    )}
                    {validationValid && (
                        <div className={css.validationValid}>
                            <CheckMark className={css.checkMark} />
                            <div><Translate id="STATIC.LOGS_DOWNLOAD.VALIDATION_VALID" /></div>
                        </div>
                    )}
                </div>

                {link && (
                    <div className={css.buttonRow}>
                        <a className="btn btn-block btn-singular btn-primary" href={link}>
                            <Translate id={isGsheet ? 'STATIC.LOGS_DOWNLOAD.BTN_OPEN_GSHEET' : 'STATIC.LOGS_DOWNLOAD.BTN_DOWNLOAD'} />
                        </a>
                    </div>
                )}

                {isFailure && (
                    <div className={css.header}>
                        {showErrorMessage ? (
                            <h2 className={css.failure}>{showErrorMessage}</h2>
                        ) : (
                            <h2 className={css.failure}><Translate id="STATIC.LOGS_DOWNLOAD.FAILURE_GENERIC" /></h2>
                        )}
                    </div>
                )}

                {!link && !validationValid && (
                    <div className={css.progressRow}>
                        <div className={css.track}>
                            <div className={css.fill} />
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}

DownloadLog.propTypes = {
    status: PropTypes.string.isRequired,
    link: PropTypes.string,
    isGsheet: PropTypes.bool,
    showErrorMessage: PropTypes.string,
    validationValid: PropTypes.bool,
    mode: PropTypes.number.isRequired,
    validationType: PropTypes.string,
    logType: PropTypes.string,
};

export default DownloadLog;
